<mat-card class="mb-10 tagus-card" [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()">
    <mat-card-content>
        <ul class="list ps-0 mb-0 mt-0 action-btn" 
            *ngIf="(permissions_entity.modules.mail_box | permissions : permissions_entity.access.edit)">
            <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="openAssignPopup()">
                    Assign
                </button>
            </li>
            <!-- <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="openCAMSSearchPopup()">
                    CAMS Id Quick Search
                </button>
            </li> -->
            <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="referToManagement()">
                    Refer to Management
                </button>
            </li>
            <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="sendToImportant()">
                    Send to Important
                </button>
            </li>
            <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="sendToDone()">
                    Send to Done
                </button>
            </li>
            <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="moveToJunk()">
                    Move to Junk
                </button>
            </li>
            <li class="gray-color">
                <button mat-flat-button class="tagus act-btn" (click)="openReferURMPopup()">
                    Refer to URM
                </button>
            </li>
        </ul>

        <div class="mat-elevation-z8 tagus-mat-table mt-10" *ngIf="show_app_table">
            <table mat-table [dataSource]="dataSource">
                <!-- Order ID Column -->
                <ng-container matColumnDef="camsID" >
                    <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">CAMS ID</th>
                    <td mat-cell *matCellDef="let element" class="fw-semibold text-start">{{element.id}}</td>
                </ng-container>

                <!-- Store -->
                <ng-container matColumnDef="store" >
                    <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">Store</th>
                    <td mat-cell *matCellDef="let element" class="text-start">
                        {{element?.store?? '-'}}
                    </td>
                </ng-container>

                <!-- Student Name -->
                <ng-container matColumnDef="studentName" >
                    <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">Student Name</th>
                    <td mat-cell *matCellDef="let element" class="text-start">
                        <!-- {{element?.student?.firstName}}&nbsp;{{element?.student?.lastName}} -->
                        <ng-container *ngIf="element?.name?.length > 15; else small_name_name">
                            <span class="fw-semibold">{{element?.name | slice:0:15}} </span>
                            <span matTooltip="{{element?.name}}">...</span>
                        </ng-container>
                        <ng-template #small_name_name>
                            <span class="fw-semibold">{{element?.name ?? '-'}}</span>
                        </ng-template><br>
                    </td>
                </ng-container>

                <!-- Student Name -->
                <ng-container matColumnDef="courseName" >
                    <th mat-header-cell *matHeaderCellDef class="text-start">Course Name</th>
                    <td mat-cell *matCellDef="let element" class="text-start">
                        <ng-container *ngIf="element?.coursesEnrolement?.courseName?.length > 15; else small_course_name">
                            <span class="">{{element?.coursesEnrolement?.courseName | slice:0:15}}</span>
                            <span matTooltip="{{element?.coursesEnrolement?.courseName}}">...</span>
                        </ng-container>
                        <ng-template #small_course_name>
                            {{element?.coursesEnrolement?.courseName}}
                        </ng-template>
                    </td>
                </ng-container>

                <!-- Student Name -->
                <ng-container matColumnDef="universityName" >
                    <th mat-header-cell *matHeaderCellDef class="text-start">University</th>
                    <td mat-cell *matCellDef="let element" class="text-start">
                        <ng-container *ngIf="element?.coursesEnrolement?.universityName?.length > 15; else small_uni_name">
                            <span class="">{{element?.coursesEnrolement?.universityName | slice:0:15}}</span>
                            <span matTooltip="{{element?.coursesEnrolement?.universityName}}">...</span>
                        </ng-container>
                        <ng-template #small_uni_name>
                            {{element?.coursesEnrolement?.universityName}}
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="primaryStatus">
                    <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
                        {{ "Primary Status" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-start">
                        <span class="badge fw-medium app-status">
                            {{ element.primaryStatus}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="secondaryStatus">
                    <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
                        {{ "Secondary Status" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-start">
                        <span class="badge fw-medium app-status">
                            {{ element.secondaryStatus}}
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

        <div class="row justify-content-end mt-10" *ngIf="show_app_table">
            <button mat-stroked-button color="warn" 
                (click)="show_app_table = false">
                    Hide
            </button>
        </div>
    </mat-card-content>
</mat-card>

<!-- <div class="info-list d-flex" [ngClass]="{'actvity-items': type === 'mail-details'}">
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <i class="ri-more-2-fill"></i>
    </button>
    <mat-menu
        #menu="matMenu"
        class="dotMenu monthMenu"
        xPosition="before"
    >
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
            (click)="openAssignPopup()"
        >
            Assign
        </button>
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
            (click)="openCAMSSearchPopup()"
        >
            CAMS Id Quick Search
        </button>
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
        >
            Refer to Management
        </button>
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
        >
            Send to Important
        </button>
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
        >
            Send to Done
        </button>
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
        >
            Move to Junk
        </button>
        <button
            mat-menu-item
            type="button"
            class="bg-transparent border-none position-relative"
            (click)="openReferURMPopup()"
        >
            Refer to URM
        </button>
    </mat-menu>
</div> -->